import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=b6cdcb4e&scoped=true"
import script from "./PhotoGallery.vue?vue&type=script&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&lang=js"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=b6cdcb4e&prod&lang=scss&scoped=true"
import style1 from "./PhotoGallery.vue?vue&type=style&index=1&id=b6cdcb4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cdcb4e",
  null
  
)

export default component.exports